import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const scrollToHash = () => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));

      if (target) {
        const isAtTarget = Math.abs(target.getBoundingClientRect().top) < 2;
        if (!isAtTarget) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };

    const timers = [
      window.setTimeout(scrollToHash, 50),
      window.setTimeout(scrollToHash, 800),
      window.setTimeout(scrollToHash, 1500),
    ];

    return () => timers.forEach((timer) => window.clearTimeout(timer));
  }, [pathname, hash]);

  return null;
}
